import { render, staticRenderFns } from "./ForecastApp9.vue?vue&type=template&id=20a3c54e&"
import script from "./ForecastApp9.vue?vue&type=script&lang=js&"
export * from "./ForecastApp9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports